import React from "react";

export const ItemListServices = ({
  item,
  index,
  handleChangeServices,
  isView,
}) => {
  return (
    <tr id={index} className="product" key={index}>
      <th scope="row" className="product-id">
        {index !== undefined ? index + 1 : ""}
      </th>
      <td className="text-start">{item?.name}</td>
      <td className="text-start">
        {Number(item.price || "0").toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }) || 0}
      </td>
      <td>
        {!isView && (
          <div className="hstack fs-15">
            <div
              to="#"
              className="link-primary"
              onClick={() => {
                handleChangeServices(index);
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <i className="ri-settings-4-line"></i>
            </div>
          </div>
        )}
      </td>
    </tr>
  );
};
